<template>
  <div class="homePg">
    <van-popup v-model="firstFlag" @close="closeInvite()" round closeable>
      <div class="invitePop">
        <img v-lazy="inviteImage" />
        <div class="popFt mt-20">
          <p>请输入你的邀请码：</p>
          <br />
          <input v-model="code" />
          <van-button
            type="default"
            @click="checkInvitePop()"
            class="popbtn"
            v-if="!success"
            >确认</van-button
          >
          <van-button
            type="default"
            @click="closeInvite()"
            class="popbtn bgblue"
            >无邀请码</van-button
          >
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="show"
      @close="close()"
      round
      style="background: rgba(255, 255, 255, 0)"
    >
      <div class="pop1">
        <img class="pop-img1" v-lazy="resBgImg1" />
        <div class="popFt">
          <van-button
            @click="checkPop()"
            type="warning"
            v-if="!success"
            class="popbtn"
            >领取优惠卷</van-button
          >
          <van-button
            type="warning"
            @click="couponSuccess()"
            class="popbtn getCoupon"
            v-if="success"
            >领取成功</van-button
          >
        </div>
        <div style="text-align: center">
          <img @click="show = false" class="closeImg" v-lazy="closeImg" />
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="showphone"
      @close="close()"
      round
      closeable
      style="background-color: #fff"
    >
      <header class="login">
        <div class="topText">绑定手机号</div>
        <div class="handset ml-20 flex pb-5 number" style="margin-left: 32px">
          <span class="baliu" style="margin-right: 5px">+86 ></span
          ><input
            v-model="phone"
            class="f14"
            type="number"
            placeholder="请输入手机号"
          />
        </div>
        <div class="zhuce"></div>
        <div
          class="handset ml-20 flex jc-sb mt-20 pb-5"
          style="margin-left: 32px; font-size: 15px; margin-right: 30px"
        >
          <input v-model="smsCode" class="f14" placeholder="请输入验证码" />
          <input
            @click="sendCode"
            class="yanzhenma"
            type="button"
            id="getcode"
            value=" 获取验证码"
          />
        </div>
        <button
          @click="login"
          class="butt ml-20 mr-20 fff botton"
          style="background: #42686e; margin-top: 59px; margin-bottom: 16px"
        >
          登录
        </button>
      </header>
    </van-popup>
    <!-- 搜索栏 -->
    <div style="display: flex" v-if="searchFlag">
      <van-search
        @click="changeSearch()"
        v-model="search"
        @search="searchApi()"
        @clear="unableSearch()"
        placeholder="输入测评关键字"
      />
      <div v-if="!search" @click="changeSearch()" class="sbutton">取消</div>
      <div v-else @click="searchApi()" class="sbutton sbuttons">搜索</div>
    </div>
    <div @click="changeSearch()" v-else>
      <van-search
        v-model="search"
        style="width: 98vw"
        @search="searchApi()"
        @clear="unableSearch()"
        placeholder="输入测评关键字"
      />
    </div>
    <div class="searchContent" v-if="searchFlag">
      <Search
        :test.sync="searchTest"
        :htest="hTests"
        :flag="searchFlag"
        :resFlag="resFlag"
        @tag="setTag($event)"
      ></Search>
    </div>
    <div class="main" v-if="!searchFlag">
      <!-- 轮播图 -->
      <van-swipe class="banner mt-5" :autoplay="3000">
        <van-swipe-item v-for="(item, index) in list" :key="index">
          <img v-lazy="item.image" class="bdr25" @click="checkBanner(item)" />
        </van-swipe-item>
      </van-swipe>
      <!-- 快速搜索 -->
      <div class="newClass">
        <div @click="searchType('亲密关系')">
          <img :src="require('../../assets/img/test/1.1.png')" />
          <div>亲密关系</div>
        </div>
        <div @click="searchType('情绪自查')">
          <img :src="require('../../assets/img/test/2.png')" />
          <div>情绪自查</div>
        </div>
        <div @click="searchType('健康睡眠')">
          <img :src="require('../../assets/img/test/3.png')" />
          <div>健康睡眠</div>
        </div>
        <div @click="searchType('自我成长')">
          <img :src="require('../../assets/img/test/4.png')" />
          <div>自我成长</div>
        </div>
      </div>
      <div class="ht ml-10">
        <!-- 最新测评 -->
        <div class="check_more_box">
          <div style="display: flex; flex-direction: column">
            <p class="h1 f20 mt-20" style="color: #42686e"><b>最新</b>测评</p>
            <p class="f10 mt-10 gray">用最新的方式与自己对话</p>
          </div>
          <div class="check_more_text mt-20" @click="goHotTest()">
            查看更多<img
              style="width: 7px; height: 9px; margin-left: 1px"
              v-lazy="require('../../assets/img/test/blackright.png')"
            />
          </div>
        </div>
        <div class="content">
          <div class="wrapper">
            <div
              class="in-wrapper"
              v-for="item in hTests"
              :key="item.id"
              @click="goLink(item.id)"
            >
              <div class="imgBox">
                <img v-lazy="item.home_image" class="bdr8" />
              </div>
              <p>{{ item.title }}</p>
              <p>
                <span class="orange f14">￥{{ item.discount_price }}</span>
                <s class="gray f10 ml-5">￥{{ item.original_price }}</s>
              </p>
            </div>
          </div>
        </div>
        <hr />
        <!-- 热门测评 -->
        <div class="nt">
          <div class="check_more_box">
            <div style="display: flex; flex-direction: column">
              <p class="h1 f20 mt-5" style="color: #42686e"><b>热门</b>测评</p>
              <p class="f10 mt-10 gray">大家都在测</p>
            </div>
            <div class="check_more_text mt-20" @click="goNewTest()">
              查看更多<img
                style="width: 7px; height: 9px; margin-left: 1px"
                v-lazy="require('../../assets/img/test/blackright.png')"
              />
            </div>
          </div>
        </div>
        <div class="content mt-20">
          <div v-for="item in nTests" :key="item.id">
            <Card :item="item"></Card>
          </div>
        </div>
        <van-button type="default" @click="goAllTest()" class="allbtn"
          >全部测评&nbsp;<img
            style="width: 7px; height: 9px; margin-left: 1px; font-size: 18px"
            v-lazy="require('../../assets/img/test/blackright.png')"
        /></van-button>
      </div>
    </div>
    <Footer page="index"></Footer>
  </div>
</template>

<script>
import { constants } from "crypto";
import store from "./../../store/index";
import { mapGetters } from "vuex";
import Footer from "@/components/Footer";
import Card from "@/components/Card";
import Search from "@/components/Search";
import { Message } from "element-ui";
import { syncToken } from "@/mixin/index";
import sdk from "../../mixin/share";
import {
  getBanner,
  getTests,
  getHotTag,
  getPopUp,
  getCoupon,
  applyCode,
  getMood,
  smsSend,
  loginNew1,
  sendMood,
} from "@/http/api";
export default {
  data() {
    return {
      // 登录相关
      isNone: false,
      keyword: "搜索",
      phone: "",
      smsCode: "",
      time: 60,
      turn: false,
      t: "",
      showphone: false,
      // 弹窗相关
      showMood: false,
      moodValue: 0,
      show: false,
      showcs: true,
      success: false,
      closeImg: require("./../../assets/img/test/close.png"),
      resBgImg1: require("./../../assets/img/test/youhui.png"),
      popIndex: sessionStorage.popIndex ? parseInt(sessionStorage.popIndex) : 0,
      showPop: {
        popup_type: {},
      },
      popData: [],
      search: "",
      searchFlag: false,
      resFlag: false,
      searchTest: [],
      linkAddr: "",
      // banner
      list: [],
      // 热门测评
      hTests: [],
      // 最新测评
      nTests: [],
      resBgImg: require("./../../assets/img/test/mood.png"),
      // 填写邀请码弹窗
      inviteImage: require("./../../assets/img/test/invite-bg.png"),
      firstFlag: false,
      code: "",
    };
  },
  watch: {
    showPop(val) {
      this.showPop = val;
    },
  },
  computed: {
    ...mapGetters(["user"]),
  },
  created() {
    const ua = window.navigator.userAgent.toLowerCase();
    this.isWechat = ua.match(/MicroMessenger/i) == "micromessenger";
    
    var current_token = syncToken(0);
    if (current_token) {
      getPopUp().then((res) => {
        this.popData = res.data;
        if (!this.firstFlag) {
          this.checkPopData(this.popIndex);
        }
      });
    }

    getBanner().then((res) => {
      this.list = res.data;
    });
    let testParam = {
      page: 1,
      page_size: 10,
      label: "hot",
    };
    let ntestParam = {
      page: 1,
      page_size: 10,
      label: "new",
    };
    getTests(ntestParam)
      .then((res) => {
        console.log("获取测评", res);
        this.hTests = res.data.objects;
      })
      .catch((err) => {
        console.log("error in getHotTest", err);
      });

    getTests(testParam)
      .then((res) => {
        // console.log(res)
        this.nTests = res.data.objects;
        this.searchTest = this.nTests;
      })
      .catch((err) => {
        console.log("error in getHotTest", err);
      });
  },
  components: {
    Footer,
    Card,
    Search,
  },
  methods: {
    sendCode() {
      if (this.turn) {
        return;
      }
      if (!/^1[34578]\d{9}$/.test(this.phone)) {
        // alert("手机号码有误，请重填!")
        this.$message({
          message: "手机号码有误，请重填!",
          type: "error",
        });
        return;
      }
      let params = {
        timestamp: new Date().getTime(),
        tel: this.phone,
      };
      let that = this;
      smsSend(params).then((res) => {
        if (res && res.code == "SUCCESS") {
          this.t = setInterval(function () {
            that.countdown();
          }, 1000);
          this.$message({
            message: "获取验证码成功",
            type: "success",
          });
          // alert("获取验证码成功");
          // this.countdown(e)
        } else {
          this.$message({
            message: "res.msg",
            type: "error",
          });
          // alert(res.msg)
        }
      });
    },
    countdown() {
      if (this.time == 0) {
        //这里时设置当时间到0的时候重新设置点击事件，并且默认time修改为60
        this.turn = false;
        document.getElementById("getcode").value = "获取验证码";
        document.getElementById("getcode").style.color = "#7487C3";
        this.time = 60;
        clearInterval(this.t);
      } else {
        //这里是显示时间倒计时的时候点击不生效
        this.turn = true;
        document.getElementById("getcode").value = "重新发送" + this.time;
        document.getElementById("getcode").style.color = "#ccc";
        this.time--;
      }
    },
    login() {
      // 发送请求,用post方式
      // 请求参数
      let params = {
        tel: this.phone,
        timestamp: new Date().getTime(),
        code: this.smsCode,
      };
      clearInterval(this.t);
      loginNew1(params).then((res) => {
        console.log(res);
        if (res.code == "SUCCESS") {
          this.$message({
            message: "手机号绑定成功！",
            type: "success",
          });
          this.showphone = false;
          this.show = false;
          let param = {
            coupon_id: this.showPop.coupon,
          };
          getCoupon(param).then((res) => {
            console.log(res);
            if (res.code == "SUCCESS") {
              this.success = true;
              this.$message({
                message: "优惠价领取成功",
                type: "success",
              });
            } else {
              // this.show=false
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    submitMood() {
      this.showMood = false;
      let param = {
        mood: this.moodValue,
      };
      sendMood(param)
        .then((res) => {
          console.log(11);
        })
        .catch((err) => {
          Message({
            message: "心情提交失败",
            type: "error",
          });
        });
    },
    checkBanner(item) {
      if (item.banner_type.key === "member") {
        this.$router.push("/my/vip");
      } else if (item.banner_type.key === "evaluation") {
        store.commit("set_eval_id", item.evaluation);
        this.$router.push("/test/" + item.evaluation + "/introduction");
      } else if (item.banner_type.key === "coupon") {
        let param = {
          coupon_id: item.coupon,
        };
        getCoupon(param).then((res) => {
          console.log(res);
          this.success = true;
        });
      }
    },
    // 更新弹窗
    checkPopData(index) {
      console.log(this.popData);
      console.log(index);
      if (!this.popData.length) {
        this.show = false;
        return;
      }
      if (this.popData.length > index) {
        this.show = true;
        this.success = false;
        this.showPop = this.popData[index];
        console.log(index, this.showPop);
      } else {
        this.showPop = this.popData[0];
        this.show = false;
      }
    },
    // 点击弹窗按钮
    checkPop() {
      console.log(this.showPop.popup_type.key);
      sessionStorage.setItem("popIndex", parseInt(this.popIndex) + 1);
      if (this.showPop.popup_type.key === "member") {
        this.$router.push("/my/vip");
      } else if (this.showPop.popup_type.key === "evaluation") {
        store.commit("set_eval_id", this.showPop.evaluation);
        this.$router.push("/test/" + this.showPop.evaluation + "/introduction");
      } else if (this.showPop.popup_type.key === "coupon") {
        let param = {
          coupon_id: this.showPop.coupon,
        };
        getCoupon(param).then((res) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            this.success = true;
          } else {
            // this.show=false
            this.showphone = true;
          }
        });
      }
    },
    couponSuccess() {
      this.show = false;
    },
    // 关闭弹窗
    close() {
      this.popIndex = this.popIndex + 1;
      sessionStorage.setItem("popIndex", this.popIndex);
      if (this.popIndex < this.popData.length) {
        this.checkPopData(this.popIndex);
        this.show = true;
      } else {
        this.show = false;
      }
    },
    searchType(search) {
      this.search = search;
      this.isNone = false;
      this.searchFlag = true;
      let testParam = {
        page: 1,
        search: this.search,
      };
      getTests(testParam)
        .then((res) => {
          this.resFlag = true;
          // console.log(res)
          this.searchTest = res.data.count ? res.data.objects : [];
          console.log(this.searchTest);
          if (this.searchTest.length == 0) {
            this.isNone = true;
          }
        })
        .catch((err) => {
          console.log("error in getHotTest", err);
        });
    },
    // 切换显示UI
    changeSearch() {
      if (this.search) {
        return;
      }
      this.searchFlag = !this.searchFlag;
      this.resFlag = false;
      if (!this.searchFlag) {
        this.search = "";
        let testParam = {
          page: 1,
          label: "hot",
        };
        getTests(testParam)
          .then((res) => {
            console.log(res);
            this.searchTest = res.data.objects;
          })
          .catch((err) => {
            console.log("error in getHotTest", err);
          });
      }
    },
    // 搜索
    searchApi() {
      this.isNone = false;
      this.searchFlag = true;
      let testParam = {
        page: 1,
        search: this.search,
      };
      getTests(testParam)
        .then((res) => {
          this.resFlag = true;
          // console.log(res)
          this.searchTest = res.data.count ? res.data.objects : [];
          console.log(this.searchTest);
          if (this.searchTest.length == 0) {
            this.isNone = true;
          }
        })
        .catch((err) => {
          console.log("error in getHotTest", err);
        });
    },
    // 取消搜索
    unableSearch() {
      this.searchFlag = false;
      this.search = "";
      this.resFlag = false;
    },
    setTag(tag) {
      this.search = tag.name;
      // this.searchStr = tag.name;
      let testParam = {
        page: 1,
        tag: tag.id,
      };
      getTests(testParam)
        .then((res) => {
          console.log(res);
          this.resFlag = true;
          this.searchTest = res.data.objects;
        })
        .catch((err) => {
          console.log("error in getHotTest", err);
        });
    },
    // banner 跳转
    goLink(index) {
      store.commit("set_eval_id", index);
      this.$router.push("/test/" + index + "/introduction");
    },
    // 跳转到更多热门测评
    goHotTest() {
      this.$router.push("/class");
    },
    // 跳转到最新测评
    goNewTest() {
      this.$router.push("/class");
    },
    // 查看全部测评
    goAllTest() {
      this.$router.push("/class");
    },
    // 邀请弹窗
    closeInvite() {
      this.firstFlag = false;
      localStorage.setItem("not_first_login", true);
      this.show = true;
      this.checkPopData(this.popIndex);
    },
    checkInvitePop() {
      let param = {
        fill_invite_code: this.code,
      };
      applyCode(param)
        .then((res) => {
          this.firstFlag = false;
          localStorage.setItem("not_first_login", true);
          this.show = true;
          this.checkPopData(this.popIndex);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.newClass {
  display: flex;
  justify-content: space-around;
  margin-top: 27px;
  margin-bottom: 32px;
  padding: 0 20px;
  text-align: center;
  font-size: 13px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #4a4a4a;

  img {
    width: 50px;
    height: 50px;
    margin-bottom: 12px;
  }
}

/* 本页公共样式 */
.login {
  //height: 100vh;
  background-color: #fff;
}

// 手机号码
header {
  text-align: center;

  img {
    margin: 79px auto;
  }

  // 验证码
  .handset {
    border-bottom: 1px solid #f8f8f8;

    input {
      border: none;
      outline: none;
    }
  }

  // 登录按钮
  .butt {
    margin-top: 20px;
    border-radius: 3px;
    background-color: #ff5f16;
    width: calc((260vw - 5px) / 3);
    height: 40px;
    border: none;
  }
}

.logo {
  font-size: 100px !important;
  margin-bottom: 150px;
}

.topText {
  margin-top: 111px;
  margin-left: 32px;
  margin-bottom: 70px;
  text-align: left;
  font-size: 24px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #4a4a4a;
  line-height: 36px;
}

.botton {
  height: 45px !important;
  background: #42686e !important;
  border-radius: 18px !important;
  font-size: 18px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #ffffff;
  line-height: 27px;
}

.xieyi {
  font-size: 12px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #9b9b9b;
  line-height: 18px;
}

.zhuce {
  margin-bottom: 10px;
  text-align: left;
  margin-left: 32px;
  font-size: 12px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #9b9b9b;
  line-height: 18px;
}

.baliu {
  font-size: 15px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #7487c3;
  line-height: 23px;
}

.number {
  font-size: 15px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  line-height: 23px;
}

.yanzhenma {
  background: #fff;
  font-size: 15px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #7487c3;
  line-height: 23px;
}

.invitePop {
  width: 8.8rem;
  height: 14rem;
  text-align: center;

  img {
    width: 8.8rem;
  }

  .popFt {
    p {
      margin-left: -60px;
    }
  }

  input {
    text-align: center;
    border-radius: 18px;
    line-height: 1rem;
    width: 70%;
    background-color: #eceff5;
    border: 1px solid #ededed;
    letter-spacing: 2px;
  }

  .popbtn {
    width: 70%;
    margin-top: 0.4rem;
    background-color: #f7b270;
    font-weight: bold;
    color: white;
    border-radius: 0.5rem;
  }
}

.pop {
  .pop-img {
    width: 8.8rem;
    height: 12.7rem;
    border-radius: 0.5rem;
  }

  .pop-img1 {
    width: 8.14rem;
    height: 7.29rem;
    border-radius: 0.5rem;
  }

  .pop-title {
    text-align: center;
    font-size: 0.72rem;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #4a4a4a;
    line-height: 1.09rem;
    margin-top: 0.65rem;
    margin-bottom: 0.14rem;
  }

  .pop-exc {
    text-align: center;
    font-size: 0.31rem;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #4a4a4a;
    line-height: 0.41rem;
    letter-spacing: 1px;
    margin-bottom: 0.22rem;
  }

  .pop-imglist {
    text-align: center;
    margin-bottom: 0.25rem;

    img {
      height: 0.92rem;
      width: 0.87rem;
    }
  }

  .popFt {
    height: 2.5rem;
    text-align: center;

    .popbtn {
      width: 80%;
      margin-top: 0.8rem;
      background-color: #f7b270;
      font-weight: bold;
      color: white;
      border-radius: 0.5rem;
    }

    .getCoupon {
      background-color: #7487c3;
    }

    .rightIcon {
      width: 20px;
      height: 20px;
      display: inline-block;
      background-color: green;
      border-radius: 10px;
      color: white;
      margin-left: 10px;
    }
  }
}

.homePg {
  overflow: hidden;

  .banner {
    width: 90%;
    height: 100%;
    margin-left: 5%;
    margin-top: 0;

    img {
      width: 100%;
    }
  }
}

.content {
  overflow-x: auto;
  overflow-y: hidden;
}

.wrapper {
  width: max-content;
}

.wrapper > .in-wrapper:nth-of-type(1) {
  margin-left: 0;
}

.in-wrapper {
  width: 3.2rem;
  float: left;
  height: 4.5rem;
  margin: 11px;

  .imgBox {
    width: 120px;
    height: 115px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.in-wrapper > p {
  line-height: 20px;

  .orange {
    font-weight: bolder;
  }
}

.in-wrapper > p:nth-of-type(1) {
  margin-top: 2px;
}

.htest {
  margin: 5px;

  p {
    line-height: 1rem;
  }
}

.searchBtn {
  float: right;
  width: 15%;
  height: 0.8rem;
  margin-left: 5px;
  padding: 0;

  span {
    line-height: 0.7rem;
  }
}

.yellow {
  color: yellow;
}

.discount {
  color: gray;
}

.allbtn {
  width: 80%;
  left: 10%;
  margin-bottom: 75px;
  border-radius: 8px;
  border: solid 1px #979797;
}

.van-field__body {
  width: 7.733333rem;
}

.mt-5 {
  margin-top: 11px;
}

.ml-10 {
  margin-left: 19px;
}

hr {
  width: 338px;
  margin: 11px 0 26px 0;
}

//外加

.sbutton {
  margin-top: 0.26667rem;
  border: 1px solid #9b9b9b;
  height: 0.96rem;
  padding: 10px 7px 9px 7px;
  color: #9b9b9b;
}

.sbuttons {
  background-color: #42686e;
  border: none;
  color: #fff;
}

.homePg {
  .van-icon-search {
    z-index: 1;
    width: 0.5rem;
    border-radius: 5px;
  }

  .card {
    .detail {
      margin-right: 22px;

      .right {
        margin-right: 0;
      }
    }
  }

  .van-field__control {
    background-color: #eceff5;
    border-radius: 5px;
    margin-left: -25px;
    padding-left: 29px;
    width: 9.066667rem;
  }

  .van-search {
    padding-left: 0.426667rem;
    padding-right: 0.426667rem;
    padding-bottom: 0.4rem;
    background-color: #fff;
    width: calc(100vw - 65px);
  }

  .van-cell {
    line-height: 36px;
    width: 343px;
    height: 36px;
    display: flex;
    align-items: center;
  }

  .van-search__content {
    width: 100%;
    padding-left: 0;
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #000;
    padding-left: 10px;
  }

  .van-icon-search {
    text-indent: 3px;
    color: #8e8e93;
  }

  .check_more {
    color: #9b9b9b;
  }

  .check_more_box {
    display: flex;
    justify-content: space-between;
  }

  .check_more_text {
    padding-right: 20px;
    padding-bottom: 10px;
    font-size: 14px;
    color: #4a4a4a;
  }
}

.pop1 {
  margin-top: -17px;
  border-radius: 24px;

  .tt {
    margin-top: 30px;
    width: 90%;
    margin-left: 5%;
  }

  .pop-img1 {
    width: 8.14rem;
    // border-radius: 0.5rem;
  }

  .pop-title {
    text-align: center;
    font-size: 0.72rem;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #4a4a4a;
    // line-height: 1.09rem;
    margin-top: -30px;
    padding-top: 40px;
    padding-bottom: 0.14rem;
    background: #fff;
  }

  .pop-exc {
    text-align: center;
    font-size: 0.31rem;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #4a4a4a;
    // line-height: 0.41rem;
    letter-spacing: 1px;
    padding-bottom: 14px;
    background: #fff;
  }

  .pop-imglist {
    text-align: center;
    margin-bottom: 0.25rem;
    padding-bottom: 44px;

    img {
      height: 0.92rem;
      width: 0.87rem;
    }
  }

  .closeImg {
    height: 30px;
    width: 30px;
    margin: 0 auto;
  }

  .popFt {
    text-align: center;
    margin-top: -34px;

    margin-bottom: 20px;

    .popbtn {
      width: 80%;
      background-color: #42686e;
      font-weight: bold;
      color: white;
      border-radius: 0.5rem;
      border: none;
    }

    .getCoupon {
      background-color: #42686e;
    }

    .rightIcon {
      width: 20px;
      height: 20px;
      display: inline-block;
      background-color: green;
      border-radius: 10px;
      color: white;
      margin-left: 10px;
    }
  }

  .popbtn {
    width: 80%;
    // margin-left: 10%;
    // font-weight: bold;
    font-size: 18px;
    color: white;
    border-radius: 0.5rem;
  }

  .reduce {
    display: inline-block;
    background: url("./../../assets/img/test/reduce.png") no-repeat center
      center;
    background-size: 100%, 100%;
    width: 25px;
    height: 25px;
  }

  .reduce-1 {
    display: inline-block;
    background: url("./../../assets/img/test/reduce-1.png") no-repeat center
      center;
    background-size: 100%, 100%;
    width: 25px;
    height: 25px;
  }

  .number {
    vertical-align: super;
    margin-top: -10px;
    display: inline-block;
    padding: 5px;
  }

  .add {
    display: inline-block;
    background: url("./../../assets/img/test/add.jpg") no-repeat center center;
    background-size: 100%, 100%;
    width: 25px;
    height: 25px;
  }

  img {
    width: 8.8rem;
    border-radius: 0.5rem;
  }

  .rightIcon {
    width: 20px;
    height: 20px;
    background-color: green;
    border-radius: 10px;
    color: white;
    position: absolute;
    top: 50%;
    right: 23px;
    transform: translateY(-50%);
    line-height: 20px;
  }
}
</style>
